import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormSelect',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  // language=HTML (for PhpStorm)
  template: `
    <div
      class="ui-select"
      :class="[
        {
          'is-inline': inline,
          'is-disabled': disabled,
          'ui-input-group': $slots.prepend || $slots.append,
          'ui-input-group--append': $slots.append,
          'ui-input-group--prepend': $slots.prepend,
        }
      ]"
    >
      <div class="ui-input-group__prepend" v-if="$slots.prepend">
        <slot name="prepend"></slot>
      </div>
      <select
        ref="input"
        class="ui-select__inner"
        :class="inputClass"
        :style="inputStyle"
        v-bind="$attrs"
        :id="computedId"
        :disabled="disabled"
        :value="currentValue"
        @input="handleInput"
        @change="handleChange"
        @blur="handleBlur"
      >
        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.label }}</option>
      </select>
      <div class="ui-input-group__append" v-if="$slots.append">
        <slot name="append"></slot>
      </div>
    </div>
  `,

  props: {
    id: String,
    disabled: Boolean,
    value: [String, Number],
    inline: {
      type: Boolean,
      default: false,
    },
    options: Array,
    inputClass: {
      type: [Array, Object, String],
      default() {
        return []
      },
    },
    inputStyle: {
      type: [Array, Object],
      default() {
        return {}
      },
    },
  },

  data() {
    return {
      currentValue: this.value === undefined || this.value === null ? '' : this.value,
    }
  },

  computed: {
    computedId() {
      if (this.id) {
        return this.id
      }

      return this.uiFormItem.computedId
    },
  },

  methods: {
    setCurrentValue(value) {
      this.currentValue = value
    },

    handleInput(ev) {
      const { value } = ev.target
      this.setCurrentValue(value)
      this.$emit('input', value)
    },

    handleChange(ev) {
      const { value } = ev.target
      this.setCurrentValue(value)
      this.$emit('change', value)
      // Needed for IE11:
      this.$emit('input', value)
      this.dispatch('UiFormItem', 'ui.form.change', value)
    },

    handleBlur(ev) {
      this.$emit('blur', ev)
      this.dispatch('UiFormItem', 'ui.form.blur', [this.currentValue])
    },
  },
}
